<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h2>Dried Cooking Process Check</h2>
        <v-row>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormDriedCookingProcessCheck-date"
              :label="$$t('date')"
              v-model="localDriedCookingProcessCheck.date"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormDriedCookingProcessCheck-receivingDate"
              :label="$$t('receivingDate')"
              v-model="localDriedCookingProcessCheck.receivingDate"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormDriedCookingProcessCheck-farm"
              :label="$$t('farm')"
              v-model="localDriedCookingProcessCheck.farm"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormDriedCookingProcessCheck-cookingDate"
              :label="$$t('cookingDate')"
              v-model="localDriedCookingProcessCheck.cookingDate"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormDriedCookingProcessCheck-kgReceived"
              :label="$$t('kgReceived')"
              v-model="localDriedCookingProcessCheck.kgReceived"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormDriedCookingProcessCheck-sizeRange"
              :label="$$t('sizeRange')"
              v-model="localDriedCookingProcessCheck.sizeRange"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormDriedCookingProcessCheck-meatWeight"
              :label="$$t('meatWeight')"
              v-model="localDriedCookingProcessCheck.meatWeight"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormDriedCookingProcessCheck-saltBatchNumber"
              label="Salt Batch Number"
              v-model="localDriedCookingProcessCheck.saltBatchNumber"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4"
            v-for="(pot, index) in pots"
            :key="index"
          >
            <v-row>
              <v-col cols="12">
                <h4 class="mt-5">{{ pot.name }}</h4>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}SaltAdded`"
                  label="Salt Added"
                  v-model="localDriedCookingProcessCheck[`${pot.value}SaltAdded`]"
                />
                <ColouredValueSimple
                  v-model="localDriedCookingProcessCheck[`${pot.value}SaltAdded`]"
                  :min="pot.saltAdded"
                  :max="pot.saltAdded"
                />
                  <v-btn
                    :data-cy="`FormDriedCookingProcessCheck-handover-salt-added-${pot.value}`"
                    block
                    color="success"
                    :disabled="disablePotHandover(pot.value, pot.saltAdded)"
                    @click="handover(`${pot.name}: Salt Added`)"
                  >
                    Handover
                  </v-btn>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}TimeIn`"
                  :label="$$t('potOneTimeIn')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}TimeIn`]"
                  @input="calcTotalUpcoming"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}TempIn`"
                  :label="$$t('potOneTempIn')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}TempIn`]"
                  @input="calcTotalUpcomingTemp"
                />
                <ColouredValueSimple
                  v-model="localDriedCookingProcessCheck[`${pot.value}TempIn`]"
                  :compare="0"
                  :min="65"
                  :max="70"
                />
                <v-btn
                 :data-cy="`FormDriedCookingProcessCheck-handover-temp-in-${pot.value}`"
                  block
                  color="success"
                  @click="handover(`${pot.name}: Temp In`)"
                >
                  Handover
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}TimeCook`"
                  :label="$$t('potOneTimeCook')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}TimeCook`]"
                  @input="calcTime"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}TempCook`"
                  :label="$$t('potOneTempCook')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}TempCook`]"
                  @input="calcTotalUpcomingTemp"
                />
                <ColouredValueSimple
                  v-model="localDriedCookingProcessCheck[`${pot.value}TempCook`]"
                  :compare="0"
                  :min="92"
                  :max="98"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}TimeOut`"
                  :label="$$t('potOneTimeOut')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}TimeOut`]"
                  @input="calcTimeOutCCP"
                />
                <ColouredValueSimple
                  v-model="localDriedCookingProcessCheck[`${pot.value}TimeOutCCP`]"
                  suffix=""
                  :min="maxSize > 300 ? 120 : 90"
                  :max="undefined"
                />
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}CoreTempCheck`"
                  :label="$$t('potOneCoreTempCheck')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}CoreTempCheck`]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}TempOut`"
                  :label="$$t('potOneTempOut')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}TempOut`]"
                />
                <ColouredValueSimple
                  v-model="localDriedCookingProcessCheck[`${pot.value}TempOut`]"
                  :compare="0"
                  :min="92"
                  :max="98"
                />
                <v-btn
                :data-cy="`FormDriedCookingProcessCheck-handover-temp-out-${pot.value}`"
                  block
                  color="success"
                  @click="handover(`${pot.name}: Temp out`)"
                >
                  Handover
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  rows="3"
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}Comments`"
                  :label="$$t('potOneTimeComments')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}Comments`]"
                />
              </v-col>
              <v-col cols="12">
                <AdminOverrideField
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}TotalUpcoming`"
                  :label="$$t('potOnetotalUpcoming')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}TotalUpcoming`]"
                />
              </v-col>
              <v-col cols="12">
                <AdminOverrideField
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}TotalUpcomingTemp`"
                  :label="$$t('potOnetotalUpcomingTemp')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}TotalUpcomingTemp`]"
                />
                <ColouredValue
                  v-model="localDriedCookingProcessCheck[`${pot.value}TotalUpcomingTemp`]"
                  :value="localDriedCookingProcessCheck[`${pot.value}TotalUpcoming`]"
                  :compare="localDriedCookingProcessCheck[`${pot.value}TotalUpcomingTemp`]"
                  suffix="%"
                  :min="95"
                  :max="105"
                />
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  filled
                  :data-cy="`FormDriedCookingProcessCheck-${pot.value}Cleaned`"
                  :label="$$t('potOneCleaned')"
                  v-model="localDriedCookingProcessCheck[`${pot.value}Cleaned`]"
                />
                <v-btn
                :data-cy="`FormDriedCookingProcessCheck-handover-${pot.value}-cleaned`"
                  block
                  color="success"
                  @click="handover(`${pot.name}: Cleaned`)"
                >
                  Handover
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <SignVerification title="Cooking done by" role="Operator"
            v-model="localDriedCookingProcessCheck.cookingDoneBySignature" />
        <SignVerification title="Verified by" role="Operator"
            v-model="localDriedCookingProcessCheck.verifiedBySignature" />
        <SignVerification title="Quality Assurance" role="Operator"
            v-model="localDriedCookingProcessCheck.qualityAssuranceSignature" />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormDriedCookingProcessCheck-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormDriedCookingProcessCheck-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import dayjs from 'dayjs';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import AdminOverrideField from './AdminOverrideField.vue';
import ColouredValueSimple from './ColouredValueSimple.vue';
import ColouredValue from './ColouredValue.vue';
import SignVerification from './SignVerification.vue';

export default {
  name: 'FormDriedCookingProcessCheck',
  module: 'DriedCookingProcessCheck',
  components: {
    AdminOverrideField,
    ColouredValue,
    ColouredValueSimple,
    SignVerification,
  },
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    DriedCookingProcessCheck: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localDriedCookingProcessCheck
      */
      localDriedCookingProcessCheck: {},
      pots: [
        { name: 'Pot A', value: 'potOne', saltAdded: 8.075 },
        { name: 'Pot B', value: 'potTwo', saltAdded: 4.8 },
        { name: 'Pot C', value: 'potThree', saltAdded: 14.4 },
      ],
    };
  },
  computed: {

    /**
   * Returns the maxSize property
   */
    maxSize() {
      const { sizeRange } = this.localDriedCookingProcessCheck;
      console.debug(sizeRange);
      if (sizeRange) {
        const ranges = sizeRange.split('-');
        console.debug(ranges);
        if (ranges.length === 2) {
          const result = Number.parseFloat(ranges[1]);
          return result;
        }
      }
      return 0;
    },
  },
  watch: {
    DriedCookingProcessCheck() {
      this.localDriedCookingProcessCheck = this.DriedCookingProcessCheck;
    },
  },
  created() {
    this.localDriedCookingProcessCheck = this.DriedCookingProcessCheck;
  },
  methods: {
    calcTime() {
      this.calcTimeOutCCP();
      this.calcTotalUpcoming();
    },
    calcTimeOutCCP() {
      this.pots.forEach((pot) => {
        const timeOut = this.localDriedCookingProcessCheck[`${pot.value}TimeOut`];
        const timeCook = this.localDriedCookingProcessCheck[`${pot.value}TimeCook`];
        const timeOutCCP = dayjs(`${this.localDriedCookingProcessCheck.date} ${timeOut}`).diff(`${this.localDriedCookingProcessCheck.date} ${timeCook}`, 'minutes');
        console.debug({ timeOut, timeCook, timeOutCCP });
        if (!Number.isNaN(timeOutCCP)) {
          this.localDriedCookingProcessCheck[`${pot.value}TimeOutCCP`] = timeOutCCP;
        } else {
          this.localDriedCookingProcessCheck[`${pot.value}TimeOutCCP`] = 0;
        }
      });
    },
    calcTotalUpcoming() {
      this.pots.forEach((pot) => {
        console.debug(this.localDriedCookingProcessCheck, pot);
        const timeIn = this.localDriedCookingProcessCheck[`${pot.value}TimeIn`];
        const timeCook = this.localDriedCookingProcessCheck[`${pot.value}TimeCook`];
        const upcoming = dayjs(`${this.localDriedCookingProcessCheck.date} ${timeCook}`).diff(`${this.localDriedCookingProcessCheck.date} ${timeIn}`, 'minutes');
        console.debug({ timeIn, timeCook, upcoming });
        if (!Number.isNaN(upcoming)) {
          this.localDriedCookingProcessCheck[`${pot.value}TotalUpcoming`] = upcoming;
        } else {
          this.localDriedCookingProcessCheck[`${pot.value}TotalUpcoming`] = 0;
        }
      });
    },
    calcTotalUpcomingTemp() {
      this.pots.forEach((pot) => {
        console.debug(this.localDriedCookingProcessCheck, pot);
        const tempIn = this.localDriedCookingProcessCheck[`${pot.value}TempIn`];
        const tempCook = this.localDriedCookingProcessCheck[`${pot.value}TempCook`];
        const upcomingTemp = parseFloat(tempCook) - parseFloat(tempIn);
        console.debug({ tempIn, tempCook, upcomingTemp });
        if (!Number.isNaN(upcomingTemp)) {
          this.localDriedCookingProcessCheck[`${pot.value}TotalUpcomingTemp`] = upcomingTemp;
        } else {
          this.localDriedCookingProcessCheck[`${pot.value}TotalUpcomingTemp`] = 0;
        }
      });
    },
    disablePotHandover(potValue, saltAdded) {
      const newSaltAdded = parseFloat(this.localDriedCookingProcessCheck[`${potValue}SaltAdded`]);
      const result = newSaltAdded !== saltAdded;
      console.debug(potValue, saltAdded, newSaltAdded, result);
      return result;
    },
    handover(status) {
      this.localDriedCookingProcessCheck.status = status;
      this.$emit('save', this.localDriedCookingProcessCheck);
      this.isSaving = true;
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localDriedCookingProcessCheck);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormDriedCookingProcessCheck example

'''js
<FormDriedCookingProcessCheck :DriedCookingProcessCheck="DriedCookingProcessCheck" />
'''
</docs>
